var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-large"},[_c('b-card',[_vm._v(" 商品1 ")]),_c('b-card',[_vm._v(" 商品2 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }